import { useCallback, useMemo } from 'react';
import { useUrlParams } from '../shared/url-params/url-params';

export enum TABS_PARAMS {
  TAB_INDEX = 'tabIndex',
}

export const useAppTabs = (
  tabIds: string[],
  tabParamName = TABS_PARAMS.TAB_INDEX as string
) => {
  /**
   * Hooks
   */
  const { applyParams, queryParams } = useUrlParams();
  const tabParamValue = queryParams.get(tabParamName);

  const updateUrlParam = useCallback(
    (index: number) => {
      applyParams({
        // TODO(Benoit): Change URL param name to "tab" only. E.g. `&tab=Holdings`
        [tabParamName]: tabIds[index],
      });
    },
    [applyParams, tabIds, tabParamName]
  );
  const tabIndex = useMemo(() => {
    if (!tabParamValue) {
      return 0;
    }

    const tabIdIndex = tabIds.indexOf(tabParamValue);

    if (tabIdIndex === -1) {
      return 0;
    }

    return tabIdIndex;
  }, [tabIds, tabParamValue]);

  /**
   * Return
   */
  return {
    tabIndex,
    updateUrlParam,
  };
};
